import '@testing-library/jest-dom';
import { render, screen } from '@testing-library/react';
import userEvent from '@testing-library/user-event';

import { Accordion } from './Accordion';

describe('Accordion', () => {
  it('should render', () => {
    render(<Accordion title="Test Accordion" content="Test Content" />);
    const titleElement = screen.getByText('Test Accordion');
    expect(titleElement).toBeInTheDocument();
    expect(titleElement).toHaveAttribute('aria-expanded', 'false');
  });

  it('should display content when expanded by default', () => {
    render(<Accordion title="Test Accordion" content="Test Content" expanded />);
    const titleElement = screen.getByText('Test Accordion');
    expect(titleElement).toBeInTheDocument();
    expect(titleElement).toHaveAttribute('aria-expanded', 'true');
  });

  it('should toggle content visibility on click', async () => {
    render(<Accordion title="Test Accordion" content="Test Content" />);
    const titleElement = screen.getByText('Test Accordion');
    await userEvent.click(titleElement);
    expect(titleElement).toHaveAttribute('aria-expanded', 'true');
    await userEvent.click(titleElement);
    expect(titleElement).toHaveAttribute('aria-expanded', 'false');
  });

  it('should toggle content visibility on Enter key press', async () => {
    render(<Accordion title="Test Accordion" content="Test Content" />);
    const titleElement = screen.getByText('Test Accordion');
    await userEvent.keyboard('[Tab]');
    await userEvent.keyboard('[Enter]');
    expect(titleElement).toHaveAttribute('aria-expanded', 'true');
    await userEvent.keyboard('[Enter]');
    expect(titleElement).toHaveAttribute('aria-expanded', 'false');
  });

  it('should toggle content visibility on Space key press', async () => {
    render(<Accordion title="Test Accordion" content="Test Content" />);
    const titleElement = screen.getByText('Test Accordion');
    await userEvent.keyboard('[Tab]');
    await userEvent.keyboard('[Space]');
    expect(titleElement).toHaveAttribute('aria-expanded', 'true');
    await userEvent.keyboard('[Space]');
    expect(titleElement).toHaveAttribute('aria-expanded', 'false');
  });
});
